import { useTranslation } from 'react-i18next';
import './PaymentPage.css';

export interface TransactionErrorAction {
  labelKey: string;
  onClick: () => void;
}

interface TransactionErrorProps {
  titleKey: string;
  descriptionKey: string;
  primaryAction?: TransactionErrorAction;
  secondaryAction?: TransactionErrorAction;
}

/**
 * Componente reutilizable de error transaccional (pago, reserva, etc.).
 * Usa solo claves i18n; sin texto hardcodeado.
 */
export function TransactionError({
  titleKey,
  descriptionKey,
  primaryAction,
  secondaryAction,
}: TransactionErrorProps) {
  const { t } = useTranslation();

  return (
    <div className="payment-container">
      <div className="payment-content error">
        <div className="error-icon">❌</div>
        <h2>{t(titleKey)}</h2>
        <p>{t(descriptionKey)}</p>
        <div className="button-group">
          {primaryAction && (
            <button onClick={primaryAction.onClick} className="close-button">
              {t(primaryAction.labelKey)}
            </button>
          )}
          {secondaryAction && (
            <button onClick={secondaryAction.onClick} className="close-button" style={{ background: '#666' }}>
              {t(secondaryAction.labelKey)}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
